const Title = ({ text, icon }) => {
    return (
      <div className="d-flex align-items-center mb-4">
        {icon && <i className={`fas fa-${icon} me-2`}></i>}
        <h2 className="m-0">{text}</h2>
      </div>
    );
  };

  export default Title;